import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

interface AppState {
  count: number
  increment: () => void
  decrement: () => void
  reset: () => void
}

export const useAppStore = create<AppState>()(
  devtools(
    immer((set) => ({
      count: 0,
      increment: () =>
        set((state) => {
          state.count += 1
        }),
      decrement: () =>
        set((state) => {
          state.count -= 1
        }),
      reset: () =>
        set((state) => {
          state.count = 0
        })
    })),
    { name: 'app-store' }
  )
)
